module.exports = __webpack_public_path__ + "static/s103_large-47e46e78c8b9eb1e9e0624e71c2e218e.jpg";